import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/operators";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    operators: [],
 
  },

  mutations: {
    setOperators(state, data) {
      state.operators = data;
    },
  
  },
  actions: {
    async getOperators(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getOperators();

          state.commit("setOperators",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

  },
});
